import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const deleteActivity = async ({ jwt, activityId }) => {
  try {
    await fetchAPI({
      url: `${APIS.deleteActivity}${activityId}`,
      method: 'DELETE',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
